import { render } from "./SSO.vue?vue&type=template&id=7504e5b8&ts=true"
import script from "./SSO.vue?vue&type=script&lang=ts"
export * from "./SSO.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/rathasitjearnpasawarn/var/apps/happily-accounts/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__